<template>
  <li class="py-4 grid grid-cols-12">
      <div class="col-span-6">
        <h4 class="text-sm  font-medium text-gray-900">
          {{ invite.attributes.firstName}} {{ invite.attributes.lastName}}
        </h4>
        <p class="text-xs text-gray-600">{{ invite.inviteeEmailAddress}}</p>
        <p class="text-sm text-gray-500">
          {{ invite.attributes.status | capitalize }} on
          {{ invite.attributes.updatedDate | moment('Do MMM YYYY, h:mm:ss a') }}
        </p>
      </div>
      <div class="col-span-4">
        <h4 class="text-sm  font-medium text-gray-900">Permissions</h4>
        <ul class="text-sm text-gray-500 space-y-1">
          <li
            v-for="permission in invite.attributes.permissions"
            :key="permission.app"
            class="flex space-x-2 items-center"
          >
            <p>{{ appLabel(permission.app) }}</p>
            <m-badge type="BLUE" textClass="text-xs">
              {{permission.level | capitalize}}
            </m-badge>
          </li>
        </ul>
      </div>
      <div
        v-if="invite.attributes.status === 'INVITED'"
        class="col-span-2 col-start-11 flex justify-end items-center"
      >
        <div class="relative">
          <m-button
            class="text-sm font-medium"
            @click="revokeInvite"
            :data-test="`revoke-invite-${invite.uuid}`"
          >
            Revoke
          </m-button>
          <div
              class="absolute inset-0 flex items-center justify-center bg-blue-800 rounded"
              v-if="loading"
            >
              <div class="h-4 w-4">
                <m-loader class="text-white"></m-loader>
              </div>
            </div>
        </div>
      </div>
    </li>
</template>

<script>
import { API, ENDPOINTS } from '@/app/services/api-url';
import EventBus from '@/app/eventBus';
import HeffronApps from '@/app/constants/account/HeffronApps.json';

export default {
  name: 'account-invite-user-item',
  props: {
    invite: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    accountID() {
      return this.$store.getters['account/getActiveAccount'].uuid;
    },
    appLabel() {
      return permissionApp => HeffronApps.filter(app => app.appName === permissionApp)[0].display;
    },
  },
  methods: {
    revokeInvite() {
      this.loading = true;

      const payload = {
        inviteUUID: this.invite.uuid,
        accountUUID: this.accountID,
      };

      return API.post(ENDPOINTS.POST_REVOKE_INVITE, payload)
        .then(() => {
          const message = `Successfully Revoked Invite for user - ${this.invite.inviteeEmailAddress}`;
          EventBus.$emit('addNotification', {
            title: 'User Invite Revoked.',
            icon: 'tick',
            message,
          });
          this.$emit('invite-revoked');
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
